module.exports = __webpack_public_path__ + "static/assets/215d6aedf5bca70a4b469ffe6d7e1056.svg";